import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import moment from 'moment';

const ModulesRepository = RepositoryFactory.get('modules');

// initial state
// shape: [{ id, quantity }]
const state = {
    templateModules: [],
    lastUpdateTime: null
};

const CACHE_TIME_MS = 2 * 60 * 1000; // 2 minutes in ms

// getters
const getters = {
    templateModules: (state) => {
        return state.templateModules
    },
    lastUpdateTime: (state) => {
        return state.lastUpdateTime;
    }
};

// actions
const actions = {
    async fetchTemplateModules({commit, getters}, forceReload = false) {
        if (forceReload || getters.templateModules.length === 0 || (getters.lastUpdateTime === null ||
            (moment().valueOf()) - CACHE_TIME_MS > getters.lastUpdateTime)) {
            const {data} = await ModulesRepository.getModuleTemplates();
            commit('setLastUpdateTime');
            data.forEach(module => {
                module.action = [
                    'edit',
                    'copy',
                    'delete'
                ]
            });
            commit('setTemplateModules', {modules: data});
        }
    }
};

// mutations
const mutations = {
    setTemplateModules(state, {modules}) {
        state.templateModules = modules;
    },
    setLastUpdateTime(state) {
        state.lastUpdateTime = moment().valueOf();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}